import styles from './MetricStrip.module.css'

/**
 * Horizontal metric strip for top-level KPIs.
 */
export function MetricStrip({ children, className = '' }) {
  return (
    <div className={`${styles.strip} ${className}`}>
      {children}
    </div>
  )
}

/**
 * Single metric within a MetricStrip.
 * @param {string} variant - 'success' | 'warning' | 'error' | 'neutral' (default)
 */
export function Metric({ label, value, variant = 'neutral', className = '' }) {
  const variantClass = variant !== 'neutral' ? styles[variant] || '' : ''

  return (
    <div className={`${styles.metric} ${variantClass} ${className}`}>
      <span className={styles.value}>{value ?? '—'}</span>
      <span className={styles.label}>{label}</span>
    </div>
  )
}
